<template>
    <div class="nom_repeat">
        <div class="head">
            <header class="header-wrap">
                <div class="header">
                    <i class="left"
                       @click="back"></i>
                    <div class="theme">{{title}}</div>
                </div>
            </header>
            <div class="give">{{list.score}}</div>
        </div>
        <ul class="list">
            <li class="title">
                <div>单词（{{list.list.length}}）</div>
                <div>评分</div>
                <div>录音</div>
            </li>
            <li class="con"
                v-for="word in wordList">
                <div>{{word.word}}</div>
                <div class="orange">{{word.score}}</div>
                <div><i :class="audio&&word.openAudio?'openAudio':'record'"
                       @click="playaudio(word)"></i></div>
            </li>
        </ul>
        <audio :src="audio" v-if="audio" @ended="audioEnded" ref="mp3"></audio>
    </div>
</template>

<script type="text/ecmascript-6">
import loadingS from 'COMPONENTS/base/tealoading.vue';

export default {
    data () {
        return {
            type: this.$route.query.type,//课文和单词数据字段不一样，用来区分课文和单词
            list: JSON.parse(localStorage.getItem('nom_check')),
            wordList: [],
            audio:'',
        }
    },
    components: {
        loadingS
    },
    methods: {
        playaudio (word) {
            console.log(word)
            if (!word.openAudio) {
                this.wordList.forEach(v => {
                    v.openAudio = false;
                });
                this.pauseaudio(word.video);
                // try {
                //   appobject.Interactive('ys_start_audio,' + word.video);
                //   word.openAudio = true;
                // } catch (e) {
                //   //console.log(e);
                // }
                this.play2(word.video)
                word.openAudio = true;
            } else {
                word.openAudio = false;
                this.pauseaudio();
            }
            this.wordList.splice(0, 1, this.wordList[0]);
        },
        play2(audio){
            this.audio=audio
            this.$nextTick(()=>{
                this.$refs.mp3.play();
            })
        },
        pauseaudio(audio){
            this.audio=audio
            this.$nextTick(()=>{
                this.$refs.mp3.pause();
            })
        },
        goonaudio(){
            this.$refs.mp3.play();
        },
        audioEnded(){
            setTimeout(() => {
                this.audio=''
            }, 300);  
        },
    },
    destroyed () {
        localStorage.removeItem('nom_check');
    },
    created () {
        if (this.type == 1) {
            //课文和单词数据字段不一样，这里编辑字段统一
            //this.title = this.list.title;  //葛帅东修改优化
            this.title = '课文跟读';
            this.list.list = this.list.pool_list;
            this.list.list.forEach(v => {
                v.word = v.text;
            })
        } else {
            this.title = '单词跟读';
        }
        this.wordList = this.list.list;
        this.wordList.forEach(v => {
            v.openAudio = false;
        });
        let that = this;
        window.playfinished = function () {
            that.wordList.forEach(v => {
                v.openAudio = false;
            });
            that.wordList.splice(0, 1, that.wordList[0]);
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.nom_repeat {
    min-height: 100vh;
    background: #f5f9ff;
    .head {
        position: relative;
        width: 720px / $ppr;
        height: 410px / $ppr;
        background: #5e89ef url("./img/icon-repeat.png") no-repeat;
        background-size: 100% 100%;
        .header {
            background: #5e89ef;
        }
        .left {
             position: absolute;
            top: 30px / $ppr;
            left: 24px / $ppr;
            width: 18px / $ppr;
            height: 36px / $ppr;
            background: url(./img/choose_back.png) no-repeat;
            background-size: 100% 100%;
        }
        .theme {
            font-size: 36px / $ppr;
        }
        .give {
            position: absolute;
            bottom: 68px / $ppr;
            left: 50%;
            margin-left: -90px / $ppr;
            width: 180px / $ppr;
            height: 180px / $ppr;
            line-height: 180px / $ppr;
            text-align: center;
            font-size: 110px / $ppr;
            font-weight: bold;
            color: #ff6600;
            background: #fff;
            border-radius: 180px / $ppr;
        }
    }
    .list {
        padding-bottom: 24px / $ppr;
        li {
            display: flex;
            padding: 0 24px / $ppr;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            background: #fff;
            border-top: 1px / $ppr solid #e8e8e8;
            &.title {
                font-size: 28px / $ppr;
                font-weight: bold;
                color: #333;
                border-top: none;
            }
            &.con {
                font-size: 30px / $ppr;
                color: #333;
            }
            div:nth-child(1),
            div:nth-child(3) {
                width: 306px / $ppr;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            div:nth-child(2) {
                flex: 1;
                text-align: center;
            }
            div:nth-child(3) {
                position: relative;
                text-align: right;
            }
            .orange {
                font-size: 36px / $ppr;
                color: #ff6600;
            }
            .record {
                position: absolute;
                right: 0;
                top: 50%;
                margin-top: -28px / $ppr;
                display: block;
                width: 56px / $ppr;
                height: 56px / $ppr;
                background: url("./img/record.png") no-repeat;
                background-size: 100% 100%;
            }
            .openAudio {
                position: absolute;
                right: 0;
                top: 50%;
                margin-top: -28px / $ppr;
                display: block;
                width: 56px / $ppr;
                height: 56px / $ppr;
                background: url("./img/record.gif") no-repeat;
                background-size: 100% 100%;
            }
        }
    }
}
</style>
